// extracted by mini-css-extract-plugin
var _1 = "AvatarStackEditable-module__addButton--HnaVZ";
var _2 = "AvatarStackEditable-module__animateUploadProgressBarWidth--crUCm";
var _3 = "AvatarStackEditable-module__animatedBackground--qaMUb";
var _4 = "AvatarStackEditable-module__avatar--i3qDf";
var _5 = "AvatarStackEditable-module__removeIcon--Lwqap";
export { _1 as "addButton", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "avatar", _5 as "removeIcon" }
